import { Reveal } from "./motion";

export default function CompareLedger({ data, testid }) {
  const accentCls =
    data.accent === "aqua"
      ? { badge: "bg-aqualight text-teal-800", bar: "bg-aqua", head: "text-teal-800" }
      : { badge: "bg-brandlight text-amber-800", bar: "bg-brand", head: "text-brand" };

  return (
    <div className="space-y-4" data-testid={testid}>
      <Reveal>
        <div className="hidden md:grid grid-cols-2 gap-4 px-2">
          {data.cols.map((c, i) => (
            <p key={i} className={`font-mono text-xs font-bold uppercase tracking-[0.2em] ${i === 0 ? accentCls.head : "text-slate-400"}`}>
              {c}
            </p>
          ))}
        </div>
      </Reveal>
      {data.rows.map((row, i) => (
        <Reveal key={row.title} delay={Math.min(i * 0.04, 0.3)}>
          <div className="card-line overflow-hidden p-0 transition-all duration-300 hover:shadow-lg hover:shadow-ink/5" data-testid={`${testid}-row-${i + 1}`}>
            <p className="border-b border-slate-100 bg-sand/60 px-6 py-3 font-display text-sm font-bold text-ink sm:px-8">
              <span className="mr-3 font-mono text-xs font-bold text-brand">{String(i + 1).padStart(2, "0")}</span>
              {row.title}
            </p>
            <div className="grid md:grid-cols-2 gap-0 md:gap-4 px-2 py-2 sm:px-4">
              <div className="relative rounded-xl bg-white p-5 sm:p-6 md:bg-aqualight/40">
                <span className={`absolute left-0 top-4 h-[calc(100%-2rem)] w-1 rounded-full ${accentCls.bar}`} />
                <p className="font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-teal-800 md:hidden">{data.cols[0]}</p>
                <p className="mt-1 md:mt-0 text-sm leading-relaxed text-slate-700">{row.egos}</p>
              </div>
              <div className="relative rounded-xl p-5 sm:p-6 md:bg-slate-100/70">
                <p className="font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400 md:hidden">{data.cols[1]}</p>
                <p className="mt-1 md:mt-0 text-sm leading-relaxed text-slate-500">{row.other}</p>
              </div>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  );
}
